export const msftLogo: string = require("./msft-logo.svg");
